<template lang="html">
	<section class="block">
		<h3>{{ $t(`${sector}.${abast}.gases.title`) }}</h3>
		<i18n
			v-if="isReportEditable"
			:path="`${sector}.${abast}.gases.desc`"
			tag="p"
			class="note">
			<a
				href="https://www.bopa.ad/bopa/022051/Pagines/678DA.aspx"
				target="blank">
				{{ $t(`${sector}.${abast}.gases.bopa_link`) }}
			</a>
		</i18n>
		<emissions-table v-if="!skip" v-model="emissions" :editable="isReportEditable">
			<template v-slot:header>
				<th>{{ $t('report.table.concept') }}</th>
				<th>{{ $t('report.table.gas') }}</th>
				<th>{{ $t('report.table.qty') }}</th>
			</template>
			<template v-slot:body="{ item }">
				<td>{{ item.concept }}</td>
				<td>{{ item.resource.label }}</td>
				<td>{{ item.qty }}<em class="unit">{{ item.resource.unit }}</em></td>
			</template>
			<template v-slot:insert="{ insert }">
				<td>
					<input
						type="text"
						class="long"
						v-model="insert.concept"
						:placeholder="$t(`${sector}.${abast}.gases.example`)" />
				</td>
				<td>
					<dropdown-select
						v-model="insert.resource"
						:options="GAS"
						:placeholder="$t('report.table.gas')" />
				</td>
				<td :data-tooltip="isEmpty(insert.resource)
					? $t('tooltip.require.gas')
					: $t('tooltip.unit_in', { unit: insert.resource.unit })">
					<input
						v-model.number="insert.qty"
						:disabled="isEmpty(insert.resource)"
						:placeholder="isEmpty(insert.resource)
							? $t('report.table.qty')
							: insert.resource.unit"
						type="number"
						min="0"
						step="0.1" />
				</td>
			</template>
		</emissions-table>
		<p v-if="isSkipperVisible">
			<label>
				<input type="checkbox" v-model="skip" :disabled="!isReportEditable" />
				{{ $t('global.tip.skip') }}
			</label>
		</p>
	</section>
</template>

<script>
import StepBlockMixin from '@/mixins/StepBlockMixin';
import EmissionsTable from '@/components/EmissionsTable.vue';
import DropdownSelect from '@/components/DropdownSelect.vue';
import { isEmpty } from '@/utils';
import { GAS } from '@/assets/constants/resources';

export default {
	name: 'StepGases',
  keyBlock: 'gases',
	mixins: [StepBlockMixin],
	components: { EmissionsTable, DropdownSelect },
	data() {
		return { GAS };
	},
	methods: { isEmpty },
};
</script>
